import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Injectable} from '@angular/core';
import {TranslatedLanguageService} from '../../shared/services/translated-language.service';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  constructor(public translatedLanguageService: TranslatedLanguageService) {
    super();
  }

  // method copied from ng-bootstrap/src/util/util.ts because it could not be imported
  toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }

// method copied from ng-bootstrap/src/util/util.ts because it could not be imported
  isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

// method copied from ng-bootstrap/src/util/util.ts because it could not be imported
  padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split(this.getSeparator());
      if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
        return {day: this.toInteger(dateParts[0]), month: null, year: null};
      } else if (dateParts.length === 2 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1])) {
        return {day: this.toInteger(dateParts[0]), month: this.toInteger(dateParts[1]), year: null};
      } else if (dateParts.length === 3 && this.isNumber(dateParts[0]) && this.isNumber(dateParts[1]) && this.isNumber(dateParts[2])) {
        return {
          day: this.toInteger(dateParts[0]),
          month: this.toInteger(dateParts[1]),
          year: this.toInteger(dateParts[2])
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date ?
      // tslint:disable-next-line:max-line-length
      `${this.isNumber(date.day) ? this.padNumber(date.day) : ''}${this.getSeparator()}${this.isNumber(date.month) ? this.padNumber(date.month) : ''}${this.getSeparator()}${date.year}` :
      '';
  }

  private getSeparator(): string {
    if (this.translatedLanguageService.translatedLanguage.toLowerCase() === 'us') {
      return '/';
    } else {
      return '-';
    }
  }
}
